import React, { FC, useState } from 'react'
import { Dropdown, DropdownButton, Form } from 'react-bootstrap'

import {
  AutocompleteableItem,
  AutocompleteOnSelect,
  onFormChangeable,
} from 'types'
import { FilteredDropdownItem } from '../FilteredDropdownItem'
import { NoUserDropdownItem } from '../NoUserDropdownItem'

export type SignatorySelectProps = {
  existingSignatoryId: number | undefined
  items: AutocompleteableItem[]
  onSelect: (item: AutocompleteableItem) => void
}

export const SignatorySelect: FC<SignatorySelectProps> = ({
  existingSignatoryId,
  items,
  onSelect,
}) => {

  const signatoryName = () => {
    const signatory = items.find(item => item.id === existingSignatoryId)
    if (signatory) {
      return signatory.value
    }
  }

  const [query, setQuery] = useState('')
  const [selectedSignatoryName, setSelectedSignatoryName] = useState(
    signatoryName(),
  )

  const filterItem = ({ value }: AutocompleteableItem, typedQuery: string) => {
    if (typedQuery) {
      return value.toLowerCase().includes(typedQuery.toLowerCase())
    }
    return true
  }

  const selectOptionAndClearInput: AutocompleteOnSelect = item => () => {
    onSelect(item)
    setSelectedSignatoryName(item.value)
    setQuery('')
  }

  const filteredItems = () => {
    if (existingSignatoryId) {
      items.unshift({
        id: undefined,
        value: 'Remove Existing Signatory',
      })
    }

    return items.filter(item => filterItem(item, query)).sort((a, b) => {
      const nameA = a.value.toUpperCase(); // ignore upper and lowercase
      const nameB = b.value.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    })
  }

  const handleQueryChange = ({ target: { value } }: onFormChangeable) => {
    setQuery(value)
  }

  const queryResults = filteredItems().map(item => (
    <FilteredDropdownItem
      key={item.id && item.id}
      item={item}
      onSelect={selectOptionAndClearInput}
    />
  ))

  const emptyComponent = <NoUserDropdownItem query={query} />

  const dropdownContent =
    filteredItems().length > 0 ? queryResults : emptyComponent

  const title = () => {
    if (existingSignatoryId || selectedSignatoryName) {
      return selectedSignatoryName === 'Remove Existing Signatory'
        ? 'Select a Signatory'
        : selectedSignatoryName
    } else {
      return 'Select a Signatory'
    }
  }

  return (
    <DropdownButton id="user-select" title={title()} variant="icon-person">
      <Form.Control
        placeholder="Search by name"
        onChange={handleQueryChange}
        value={query}
      />
      {dropdownContent}
      <Dropdown.Divider />
    </DropdownButton>
  )
}
